// extracted by mini-css-extract-plugin
export default {"show":"WelcomeLogo_show__FEHVa","hide":"WelcomeLogo_hide__Qwou+"};